module.exports = __webpack_public_path__ + "img/return-flow-sm.8dca056b.svg";